module.exports = __webpack_public_path__ + "assets/white_close_new.4686def8d4a5aa4693936a5301adf953.svg";